import React, { useState, useEffect } from 'react';
import './body.css';
import { 
  FaUserMd, FaGavel, FaMicrochip, FaHeartbeat, 
  FaMobileAlt, FaChevronLeft, FaChevronRight, 
  FaQuoteLeft, FaStar, FaHospitalUser, FaFlask, 
  FaChartLine, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt,
  FaGraduationCap, FaBriefcase, FaEye, FaShieldAlt,
  FaGlobe, FaCheckCircle, FaClock, FaUserTie,
  FaBalanceScale, FaAppleAlt, FaDumbbell, FaChalkboardTeacher
} from 'react-icons/fa';

function Body() {

const heroImages = [
  "/medical-advisory-banner.jpeg",
  // "/medico-legal-banner.jpeg",
  "/data-science-banner.jpeg",
  "/sport-banner.jpeg",
    "/digital-accessories-banner.jpeg",
];

const [currentImage, setCurrentImage] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentImage((prev) => (prev + 1) % heroImages.length);
  }, 4000); // change every 4 seconds

  return () => clearInterval(interval);
}, []);



  const [scrolled, setScrolled] = useState(false);
  const [activeNav, setActiveNav] = useState('home');
  const [testimonialIndex, setTestimonialIndex] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveNav(sectionId);
    }
  };

  const testimonials = [
    {
      name: "Dr. Sarah Johnson",
      position: "Chief Medical Officer, City Hospital",
      text: "Dr. Jery Medico provided exceptional medico-legal advisory that helped us navigate complex regulatory challenges. Their multidisciplinary approach is truly unique and transformative for modern healthcare systems.",
      rating: 5
    },
    {
      name: "Prof. Michael Chen",
      position: "Director of Sports Medicine, National Institute",
      text: "The sports biomechanics analysis and performance optimization strategies have revolutionized our athletes' training programs. Outstanding expertise with measurable results!",
      rating: 5
    },
    {
      name: "Emily Rodriguez",
      position: "Healthcare Administrator, Wellness Center",
      text: "Their AI health informatics solutions streamlined our operations and improved patient outcomes significantly. A game-changing partnership for our organization.",
      rating: 5
    },
    {
      name: "James Wilson, Esq.",
      position: "Legal Counsel, Medical Association",
      text: "The medico-legal team's attention to detail and ethical framework is unparalleled. A trusted partner for complex medical-legal matters and litigation support.",
      rating: 5
    }
  ];

  const nextTestimonial = () => {
    setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const divisions = [
    { 
      title: "Medical Advisory & Applied Psychology", 
      desc: "Medical interpretation, behavioral insight, and strategic health guidance for optimal clinical and organizational outcomes.",
      icon: FaUserMd,
      link: "/medical-advisory-applied-psychology",
      details: "Clinical diagnostics | Behavioral modification | Stress management | Patient compliance"
    },
    { 
      title: "Medico-Legal & Medical Ethics", 
      desc: "Clinical-legal intelligence, litigation strategy, and comprehensive risk advisory for healthcare providers and insurers.",
      icon: FaGavel,
      link: "/medico-legal-medical-ethics",
      details: "Medical negligence | Expert witness | Insurance disputes | Legal compliance"
    },
    { 
      title: "Biomedical Engineering & Sports Biomechanics", 
      desc: "Scientific performance optimization, injury prevention, and advanced biomechanical analysis for athletes and active individuals.",
      icon: FaMicrochip,
      link: "/biomedical-engineering-and-sports-biomechanics-advisory",
      details: "Motion analysis | Injury prevention | Performance enhancement | Rehabilitation tech"
    },
    { 
      title: "AI Health Informatics & CSR Health Services", 
      desc: "Strategic AI adoption, data-driven insights, and measurable health impact design for modern healthcare systems.",
      icon: FaHeartbeat,
      link: "/AI-health-informatics-csr-health-services",
      details: "Predictive analytics | EHR optimization | Population health | Data governance"
    },
    { 
      title: "Digital Health Accessories & Wellness Solutions", 
      desc: "Innovative wellness technology and lifestyle products for modern healthcare needs and preventive care.",
      icon: FaMobileAlt,
      link: "/digital-health-accessories-wellness-and-sports-biomechanics-solutions",
      details: "Wearable tech | Remote monitoring | Wellness devices | Preventive solutions"
    }
  ];

  const whyChooseUs = [
    { title: "Multidisciplinary Excellence", desc: "Integration of medicine, law, engineering, psychology, and data science", icon: FaFlask },
    { title: "15+ Years Experience", desc: "Decades of combined expertise across healthcare and legal sectors", icon: FaStar },
    { title: "Global Standards", desc: "International qualifications and best practices applied locally", icon: FaHospitalUser },
    { title: "Ethical Framework", desc: "Evidence-based, transparent, and professionally accountable advisory", icon: FaChartLine }
  ];

  // Academic Qualifications Data
  const academicQualifications = [
    { degree: "MBBS", specialization: "Clinical Medicine", institution: "China", details: "2nd Class Upper Division - Clinical medicine, diagnostics, internal medicine, evidence-based clinical reasoning" },
    { degree: "BEng (Hons)", specialization: "Biomedical Engineering", institution: "London, UK", details: "First Class Honours - Human biomechanics, medical device engineering, rehabilitation technologies" },
    { degree: "LLB (Hons)", specialization: "Bachelor of Laws", institution: "London, UK", details: "Third Class Honours - Tort law, contract law, healthcare legal systems, medical negligence" },
    { degree: "LLM", specialization: "International Business Law", institution: "Cardiff, UK", details: "Distinction - International legal systems, cross-border healthcare law, corporate governance" },
    { degree: "MBA", specialization: "Health Sector Management", institution: "Cardiff, UK", details: "Healthcare operations, hospital administration, strategic leadership, organizational behavior" },
    { degree: "MSc", specialization: "Data Science with AI Health Informatics", institution: "London, UK", details: "Health data analytics, machine learning, biostatistics, AI diagnostics, healthcare cybersecurity" },
    { degree: "MSc", specialization: "Applied Psychology & Behavior Change", institution: "Cardiff, UK", details: "Behavioral modification, CBT-based coaching, stress management, decision psychology" },
    { degree: "MPhil", specialization: "Clinical Nutrition", institution: "PGIA, SL", details: "Disease-based nutrition, metabolic health, therapeutic diet systems, evidence-based dietetics" },
    { degree: "DBA", specialization: "Health Services Management", institution: "Malaysia", details: "Merit - Healthcare systems optimization, clinical governance, service delivery innovation" },
    { degree: "PhD", specialization: "Medical Law & Ethics with Applied Psychology", institution: "Cambodia", details: "Medico-legal frameworks, ethical decision-making, legal risk management, healthcare litigation" },
    { degree: "CMgr-MCPM", specialization: "Chartered Manager", institution: "SL", details: "Strategic management, corporate governance, organizational performance, executive leadership" },
    { degree: "Attorney-at-Law", specialization: "Legal Qualification", institution: "Reading", details: "Contract drafting, corporate advisory, regulatory compliance, legal research, dispute resolution" }
  ];

  // Professional Experience Data
  const professionalExperience = [
    { role: "Medical Intern & Medical Officer", period: "2011-2012", icon: FaUserMd, details: "Clinical foundation stage - Patient diagnosis, emergency care, clinical decision-making, hospital practice systems" },
    { role: "Locum Physician", period: "2012-Present", icon: FaHospitalUser, details: "Primary care, acute medical management, multi-specialty evaluation, rapid diagnostic decision-making" },
    { role: "Clinical Research Associate & Coordinator", period: "2012-2018", icon: FaFlask, details: "Clinical trial coordination, ethical research governance, patient data tracking, medical documentation" },
    { role: "Medical Advisor – Insurance & Pharmaceutical", period: "2018-2021", icon: FaBriefcase, details: "Medical claims evaluation, drug utilization advisory, insurance risk interpretation, clinical assessment" },
    { role: "Clinical Research Scientist & Medical Advisor", period: "2021-2022", icon: FaMicrochip, details: "Drug efficacy evaluation, evidence-based research interpretation, clinical development advisory" },
    { role: "Medical Advisor - Clinical Nutrition", period: "2022-2024", icon: FaAppleAlt, details: "Metabolic disease nutrition, chronic disease management, evidence-based dietetics, weight optimization" },
    { role: "Legal Advisor", period: "2024-2025", icon: FaBalanceScale, details: "Contract drafting, corporate advisory, regulatory compliance, dispute resolution, legal risk assessment" },
    { role: "Visiting Lecturer", period: "2018-Present", icon: FaChalkboardTeacher, details: "Healthcare Management, International Business Law, Medical Law & Ethics, Organizational Leadership" },
    { role: "Visiting Medico-Legal Advisor", period: "2018-Present", icon: FaGavel, details: "Medical negligence evaluation, expert witness reports, insurance dispute analysis, legal documentation" },
    { role: "Applied Psychology Consultant", period: "2025-Present", icon: FaUserTie, details: "Behavioral modification strategies, CBT-based coaching, stress management, career decision psychology" },
    { role: "Biomedical Engineering Consultant", period: "2025-Present", icon: FaDumbbell, details: "Human motion analysis, sports injury prevention, cricket biomechanics, athletic performance optimization" }
  ];

  return (
    <div className="djm-homepage">
      {/* Hero Section */}
<section id="home" className="djm-hero-section">

  {/* IMAGE SLIDER */}
  <div className="djm-hero-slider">
    {heroImages.map((img, index) => (
      <div
        key={index}
        className={`djm-slide ${index === currentImage ? "active" : ""}`}
        style={{ backgroundImage: `url(${img})` }}
      />
    ))}
  </div>



        <div className="djm-hero-overlay"></div>
        <div className="djm-hero-pattern"></div>
        <div className="djm-hero-content">
          <div className="djm-hero-badge">DR. JERY MEDICO (PVT) LTD</div>
          <h1 className="djm-hero-title">
            Integrated Medical Intelligence &<br />
            <span className="djm-hero-highlight">Medico-Legal Advisory</span>
          </h1>
          <p className="djm-hero-subtitle">Where Medicine, Law, Engineering, Psychology, Science, IT and Management converge into a single intelligence-driven healthcare ecosystem</p>
          <div className="djm-hero-buttons">
            <button className="djm-hero-cta" onClick={() => scrollToSection('divisions')}>
              Explore Divisions
              <span className="djm-cta-arrow">→</span>
            </button>
            <a href="/aboutus" className="djm-hero-secondary">
              About Our Institution
            </a>
          </div>
          <div className="djm-hero-stats">
            <div className="djm-stat-item"><span className="djm-stat-number">15+</span><span className="djm-stat-label">Years Experience</span></div>
            <div className="djm-stat-divider"></div>
            <div className="djm-stat-item"><span className="djm-stat-number">12+</span><span className="djm-stat-label">Advanced Degrees</span></div>
            <div className="djm-stat-divider"></div>
            <div className="djm-stat-item"><span className="djm-stat-number">5</span><span className="djm-stat-label">Core Divisions</span></div>
          </div>
        </div>
      </section>

      {/* FOUNDER, CEO & DIRECTOR PROFILE - Enhanced Detailed Section */}
      <section id="ceo" className="djm-ceo-section">
        <div className="djm-container">
          <div className="djm-section-header">
            <span className="djm-section-tag">Leadership</span>
            <h2 className="djm-section-title">Founder, CEO & Director</h2>
            <div className="djm-title-line"></div>
            <p className="djm-section-subtitle">A rare multidisciplinary healthcare and legal-medical executive transforming modern healthcare systems</p>
          </div>

          {/* Main Profile Card */}
          <div className="djm-ceo-main-card">
            <div className="djm-ceo-image-area">
              <div className="djm-ceo-image-wrapper">
                <img src="/dr-jery.jpeg" alt="Dr. Eng. Jerish Neeraj" />
                <div className="djm-ceo-badge">Founder & CEO</div>
              </div>
              <div className="djm-ceo-title-badges">
                <span>Physician</span>
                <span>Biomedical Engineer</span>
                <span>Medical Data Scientist</span>
                <span>Chartered Manager</span>
                <span>Medico-Legal Advisor</span>
              </div>
            </div>
            
            <div className="djm-ceo-info-area">
              <h3 className="djm-ceo-name">Dr. Eng. Jerish Neeraj</h3>
              <p className="djm-ceo-titles">
                Physician, Biomedical Engineer, Medical Data Scientist, Chartered Manager, Medical Advisor, 
                Legal Advisor, Medico-Legal Advisor, Clinical Nutrition Consultant, AI Health Informatics & 
                Management Consultant, Applied Health Psychologist, Biomechanist, Visiting Lecturer
              </p>
              
              <div className="djm-ceo-quote">
                <FaQuoteLeft className="djm-quote-icon" />
                <p>“Integrated Medical–Legal–Scientific–Behavioral Intelligence for Modern Healthcare Systems.”</p>
              </div>
              
              <div className="djm-ceo-stats">
                <div><FaGraduationCap /><span>12+ Degrees</span></div>
                <div><FaBriefcase /><span>15+ Years Exp</span></div>
                <div><FaGlobe /><span>Global Practice</span></div>
              </div>
              
              <a href="/aboutus" className="djm-ceo-btn">View Complete Profile →</a>
            </div>
          </div>

          {/* Executive Profile Section */}
          <div className="djm-executive-profile">
            <h3><FaUserTie /> Executive Profile</h3>
            <p>
              Dr. Jerish Neeraj is a rare multidisciplinary healthcare and legal-medical executive whose academic and professional 
              trajectory integrates clinical medicine, biomedical engineering, law, healthcare management, psychology, nutrition, 
              data science, and strategic leadership.
            </p>
            <p>
              He is the Founder and CEO of <strong>Dr. Jery Medico (Pvt.) Ltd.</strong>, a premium global advisory institution specializing in 
              medico-legal consulting, psychological behavior change systems, sports biomechanics, clinical nutrition optimization, 
              clinical data science, health informatics, and strategic healthcare management advisory services. His professional model 
              represents a new generation of healthcare leadership where multiple disciplines converge into a single intelligence-driven ecosystem.
            </p>
          </div>

          {/* Academic Qualifications - Detailed */}
          <div className="djm-qualifications-showcase">
            <h3><FaGraduationCap /> Academic Qualifications <span className="djm-qual-badge">Verified Multidisciplinary Framework</span></h3>
            <div className="djm-qual-grid">
              {academicQualifications.map((qual, idx) => (
                <div key={idx} className="djm-qual-card-detailed">
                  <div className="djm-qual-header">
                    <div className="djm-qual-degree">{qual.degree}</div>
                    <div className="djm-qual-institution">{qual.institution}</div>
                  </div>
                  <div className="djm-qual-specialization">{qual.specialization}</div>
                  <p className="djm-qual-details">{qual.details}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Professional Experience - Timeline */}
          <div className="djm-experience-showcase">
            <h3><FaBriefcase /> Professional Experience <span className="djm-exp-badge">15+ Years Multidisciplinary Career</span></h3>
            <div className="djm-exp-timeline">
              {professionalExperience.map((exp, idx) => (
                <div key={idx} className="djm-exp-timeline-item">
                  <div className="djm-exp-timeline-icon"><exp.icon /></div>
                  <div className="djm-exp-timeline-content">
                    <div className="djm-exp-role">{exp.role}</div>
                    <div className="djm-exp-period"><FaClock /> {exp.period}</div>
                    <p className="djm-exp-details">{exp.details}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Vision & Unique Value Position */}
          <div className="djm-vision-values">
            <div className="djm-vision-box">
              <FaEye className="djm-vision-icon" />
              <h4>Our Vision</h4>
              <p>To create a global system where medical decisions are scientifically interpreted, legal-medical conflicts are professionally structured, behavioral health is scientifically guided, sports performance is biomechanically optimized, and clinical nutrition is evidence-based.</p>
            </div>
            <div className="djm-values-box">
              <h4><FaShieldAlt /> Unique Value Position</h4>
              <ul>
                <li><FaCheckCircle /> Medical intelligence advisory system</li>
                <li><FaCheckCircle /> Medico-legal consulting framework</li>
                <li><FaCheckCircle /> Behavioral psychology advisory unit</li>
                <li><FaCheckCircle /> Sports biomechanics performance lab</li>
                <li><FaCheckCircle /> Healthcare informatics management institution</li>
              </ul>
            </div>
          </div>

          {/* Ethics & Governance Framework */}
          <div className="djm-ethics-framework">
            <h3><FaShieldAlt /> Ethics & Governance Framework</h3>
            <div className="djm-ethics-grid">
              <div className="djm-ethics-item"><FaCheckCircle /> Evidence-based advisory only</div>
              <div className="djm-ethics-item"><FaCheckCircle /> No unnecessary clinical intervention</div>
              <div className="djm-ethics-item"><FaCheckCircle /> Confidential case handling</div>
              <div className="djm-ethics-item"><FaCheckCircle /> Ethical medico-legal reporting</div>
              <div className="djm-ethics-item"><FaCheckCircle /> Professional transparency</div>
              <div className="djm-ethics-item"><FaCheckCircle /> Regulatory compliance</div>
            </div>
          </div>

          {/* Global Positioning Statement */}
          <div className="djm-global-statement">
            <FaGlobe className="djm-global-icon" />
            <p>“Where Medicine, Law, Engineering, Psychology, Science, IT and Management converge into a single intelligence-driven healthcare ecosystem.”</p>
          </div>
        </div>
      </section>

      {/* About Us Section with More Button */}
      <section id="about" className="djm-about-section">
        <div className="djm-container">
          <div className="djm-about-grid">
            <div className="djm-about-content">
              <span className="djm-section-tag">About Us</span>
              <h2 className="djm-section-title">Redefining Healthcare Advisory</h2>
              <div className="djm-title-line"></div>
              <p className="djm-about-text">
                Dr. Jery Medico (Pvt.) Ltd. is a premium global advisory institution specializing in 
                medico-legal consulting, psychological behavior change systems, sports biomechanics, 
                clinical nutrition optimization, and strategic healthcare management. 
                Our multidisciplinary approach integrates clinical medicine, biomedical engineering, 
                law, psychology, and data science to deliver unparalleled intelligence and solutions.
              </p>
              <p className="djm-about-text">
                Unlike traditional clinics, our platform operates as a comprehensive medical intelligence 
                advisory system, bridging gaps between clinical practice, legal frameworks, and technological 
                innovation for measurable outcomes.
              </p>
              <a href="/aboutus" className="djm-about-btn">More About Us →</a>
            </div>
            <div className="djm-about-stats">
              <div className="djm-stat-card"><span className="djm-stat-number">15+</span><span className="djm-stat-label">Years Combined Experience</span></div>
              <div className="djm-stat-card"><span className="djm-stat-number">12+</span><span className="djm-stat-label">Advanced Degrees</span></div>
              <div className="djm-stat-card"><span className="djm-stat-number">500+</span><span className="djm-stat-label">Clients Served</span></div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section id="why-choose-us" className="djm-why-choose-section">
        <div className="djm-container">
          <div className="djm-section-header">
            <span className="djm-section-tag">Why Choose Us</span>
            <h2 className="djm-section-title">Setting the Standard in Healthcare Advisory</h2>
            <div className="djm-title-line"></div>
            <p className="djm-section-subtitle">What makes us the preferred partner for medical and legal intelligence</p>
          </div>
          <div className="djm-why-choose-grid">
            {whyChooseUs.map((item, idx) => (
              <div key={idx} className="djm-why-card">
                <div className="djm-why-icon"><item.icon /></div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why We Are Special Section */}
      <section className="djm-special-section">
        <div className="djm-container">
          <div className="djm-special-grid">
            <div className="djm-special-content">
              <span className="djm-section-tag">Our Distinction</span>
              <h2 className="djm-section-title">Why We Are Special</h2>
              <div className="djm-title-line"></div>
              <ul className="djm-special-list">
                <li><FaCheckCircle /> Only integrated medical-legal-scientific-behavioral advisory in the region</li>
                <li><FaCheckCircle /> Founder with 12+ advanced degrees across 5 core disciplines</li>
                <li><FaCheckCircle /> Evidence-based, ethically grounded, and globally aligned frameworks</li>
                <li><FaCheckCircle /> Customized solutions for insurers, hospitals, law firms, and corporations</li>
                <li><FaCheckCircle /> Commitment to measurable outcomes and continuous innovation</li>
                <li><FaCheckCircle /> International qualifications and cross-jurisdictional expertise</li>
              </ul>
            </div>
    <div className="djm-special-image">
  <div className="djm-special-placeholder">
    <img
      src="/wywearespecial.png"
      alt="Why We Are Special"
      className="djm-special-img"
    />
  </div>
</div>
          </div>
        </div>
      </section>

      {/* Main Divisions Section */}
      <section id="divisions" className="djm-divisions-section">
        <div className="djm-container">
          <div className="djm-section-header">
            <span className="djm-section-tag">Our Expertise</span>
            <h2 className="djm-section-title">Core Advisory Divisions</h2>
            <div className="djm-title-line"></div>
            <p className="djm-section-subtitle">Integrated intelligence across five specialized domains delivering comprehensive solutions</p>
          </div>
          <div className="djm-divisions-grid">
            {divisions.map((div, idx) => (
              <div key={idx} className="djm-division-card">
                <div className="djm-division-icon"><div.icon /></div>
                <h3>{div.title}</h3>
                <p>{div.desc}</p>
                <div className="djm-division-details">{div.details}</div>
                <a href={div.link} className="djm-division-link">Learn More →</a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section with Attractive Phrase */}
      <section id="contact" className="djm-contact-section">
        <div className="djm-container">
          <div className="djm-contact-card">
            <div className="djm-contact-content">
              <h2>Let's Transform Healthcare Together</h2>
              <p className="djm-contact-phrase">Partner with us for intelligent, ethical, and results-driven advisory solutions that bridge the gap between medicine, law, and technology.</p>
              <div className="djm-contact-details">
                <div className="djm-contact-item"><FaPhoneAlt /><span>+94 77 119 9190</span></div>
                <div className="djm-contact-item"><FaEnvelope /><span>info@drjerymedico.com</span></div>
                <div className="djm-contact-item"><FaMapMarkerAlt /><span>Colombo, Sri Lanka</span></div>
              </div>
            

            <a href="/booking">
            <button className="djm-contact-btn">
              Schedule a Consultation →
            </button>
          </a>

            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section with Carousel */}
      <section id="testimonials" className="djm-testimonials-section">
        <div className="djm-container">
          <div className="djm-section-header">
            <span className="djm-section-tag">Testimonials</span>
            <h2 className="djm-section-title">What Our Clients Say</h2>
            <div className="djm-title-line"></div>
          </div>
          <div className="djm-testimonial-carousel">
            <button onClick={prevTestimonial} className="djm-carousel-btn"><FaChevronLeft /></button>
            <div className="djm-testimonial-card">
              <FaQuoteLeft className="djm-testimonial-quote" />
              <p className="djm-testimonial-text">"{testimonials[testimonialIndex].text}"</p>
              <div className="djm-testimonial-rating">
                {[...Array(testimonials[testimonialIndex].rating)].map((_, i) => (<FaStar key={i} className="djm-star" />))}
              </div>
              <h4 className="djm-testimonial-name">{testimonials[testimonialIndex].name}</h4>
              <p className="djm-testimonial-position">{testimonials[testimonialIndex].position}</p>
            </div>
            <button onClick={nextTestimonial} className="djm-carousel-btn"><FaChevronRight /></button>
          </div>
          <div className="djm-carousel-dots">
            {testimonials.map((_, idx) => (<span key={idx} className={`djm-dot ${idx === testimonialIndex ? 'active' : ''}`} onClick={() => setTestimonialIndex(idx)} />))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Body;